import LayoutPage from "../../Components/LayoutPage"
import Buttons from "./Components/Buttons"
import AdminsList from "./Components/AdminsList"

export default function Admins() {
  return (
    <LayoutPage activeIndex={15} navItems={["مدیران سامانه"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto">
      <Buttons/>
      <AdminsList/>
    </LayoutPage>
  )
}